export const catRecordEn = {
  'cat.history.empty': 'No recorded changes',
  'cat.history.forbidden': 'History is restricted',
  'cat.history.forbiddenHint': 'The audit log needs the audit permission.',
  'cat.holds.emptyTitle': 'No holds on this title',
  'cat.holds.emptyHint': 'Holds placed by patrons or staff will queue here.',
  'cat.holds.placed': 'Placed',
  'cat.holds.tableLabel': 'Hold queue',
  'cat.item.accession': 'Accession number',
  'cat.item.act.changeLibrary': 'Change library',
  'cat.item.act.damaged': 'Mark damaged',
  'cat.item.act.delete': 'Delete item',
  'cat.item.act.edit': 'Edit item',
  'cat.item.act.found': 'Mark found',
  'cat.item.act.history': 'Circulation history',
  'cat.item.act.hold': 'Place item hold',
  'cat.item.act.label': 'Print label',
  'cat.item.act.lost': 'Mark lost',
  'cat.item.act.repaired': 'Mark repaired',
  'cat.item.act.restore': 'Restore to circulation',
  'cat.item.act.withdraw': 'Withdraw',
  'cat.item.actionsFor': 'Actions for {barcode}',
  'cat.item.add': 'Add item',
  'cat.item.addTitle': 'Add item',
  'cat.item.autoBarcode': 'Generate barcode automatically',
  'cat.item.barcode': 'Barcode',
  'cat.item.barcodeAuto': 'Generated on save',
  'cat.item.barcodeAutoHint': 'Leave empty to use the next barcode in the sequence.',
  'cat.item.batchConflicts': 'These barcodes already exist: {list}',
  'cat.item.batchCopyStart': 'First copy number',
  'cat.item.batchCount': 'Copies',
  'cat.item.batchCreate': 'Create {n} copies',
  'cat.item.batchDone': '{n} copies added',
  'cat.item.batchHint': 'Create many copies with sequential barcodes. Preview first to catch clashes.',
  'cat.item.batchPrefix': 'Barcode prefix',
  'cat.item.batchPrefixHint': 'Empty = automatic',
  'cat.item.batchPreview': 'Preview',
  'cat.item.batchStart': 'Start at',
  'cat.item.batchTitle': 'Add copies in batch',
  'cat.item.batchWidth': 'Digits',
  'cat.item.batchWillCreate': 'Will create {n} copies',
  'cat.item.callNumber': 'Call number',
  'cat.item.changeLibrary': 'Change library',
  'cat.item.choose': 'Choose',
  'cat.item.classSource': 'Classification source',
  'cat.item.collection': 'Collection',
  'cat.item.copyBarcode': 'Copy barcode',
  'cat.item.copyNumber': 'Copy number',
  'cat.item.created': 'Item {barcode} added',
  'cat.item.damagedTitle': 'Mark damaged',
  'cat.item.dateAccepted': 'Date accepted',
  'cat.item.deleteBody': 'Item {barcode} will be removed from the catalogue. Items on loan cannot be deleted.',
  'cat.item.deleteTitle': 'Delete this item?',
  'cat.item.due': 'Due {date}',
  'cat.item.dueOrSeen': 'Due / last seen',
  'cat.item.editTitle': 'Edit item {barcode}',
  'cat.item.emptyHint': 'Add the first copy so patrons can borrow this title.',
  'cat.item.emptyTitle': 'No copies yet',
  'cat.item.failed': 'That did not work',
  'cat.item.filter': 'Filter copies',
  'cat.item.historyDue': 'Due {date}',
  'cat.item.historyEmpty': 'This copy has never been borrowed',
  'cat.item.historyRenewals': '{n} renewals',
  'cat.item.historyTitle': 'Circulation history',
  'cat.item.holdingLibrary': 'Holding library',
  'cat.item.homeLibrary': 'Home library',
  'cat.item.itemType': 'Item type',
  'cat.item.labelSheets': 'Print many labels at once in the label designer',
  'cat.item.labelTitle': 'Item label',
  'cat.item.location': 'Shelving location',
  'cat.item.lostStatus': 'Lost status',
  'cat.item.lostTitle': 'Mark lost',
  'cat.item.moreFields': 'More fields',
  'cat.item.noBarcode': 'No barcode',
  'cat.item.none': 'None',
  'cat.item.notForLoan': 'Loan status',
  'cat.item.note': 'Note',
  'cat.item.price': 'Price',
  'cat.item.print': 'Print',
  'cat.item.publicNote': 'Public note',
  'cat.item.replacementPrice': 'Replacement price',
  'cat.item.restricted': 'Restricted access',
  'cat.item.saved': 'Item saved',
  'cat.item.seen': 'Seen {date}',
  'cat.item.source': 'Source',
  'cat.item.staffNote': 'Staff note',
  'cat.item.status': 'Status',
  'cat.item.tableLabel': 'Copies of this title',
  'cat.item.unknownPatron': 'Unknown patron',
  'cat.item.updated': 'Item updated',
  'cat.item.volume': 'Volume',
  'cat.item.withdrawTitle': 'Withdraw item',
  'cat.marc.copy': 'Copy MARC',
  'cat.marc.formatted': 'MARC',
  'cat.marc.none': 'No MARC record stored',
  'cat.marc.noneHint': 'Edit the record to generate one.',
  'cat.marc.raw': 'Raw JSON',
  'cat.marc.tableLabel': 'MARC fields',
  'cat.marc.view': 'Record format',
  'cat.record.deleteBody': '\'{title}\' and its {n} copies will be removed. Type the record number to confirm.',
  'cat.record.deleteFailed': 'Could not delete the record',
  'cat.record.deleteTitle': 'Delete this record?',
  'cat.record.deleted': 'Record deleted',
  'cat.record.holds': '{n} holds',
  'cat.record.notFound': 'Record not found',
  'cat.record.tabs': 'Record sections',
  'cat.related.empty': 'No related titles found',
  'cat.reviews.average': 'Average rating {avg} from {n} ratings',
  'cat.reviews.empty': 'No reviews yet',
  'cat.reviews.emptyHint': 'Patrons can review titles from the public catalogue.',
  'cat.reviews.moderate': 'Open the moderation queue',
  'cat.reviews.pending': 'Pending',
  'cat.reviews.unrated': 'Not rated yet',
  'cat.tab.history': 'History',
  'cat.tab.holds': 'Holds',
  'cat.tab.items': 'Items',
  'cat.tab.marc': 'Details and MARC',
  'cat.tab.related': 'Related',
  'cat.tab.reviews': 'Reviews',
} as const;

export const catRecordHi: Record<keyof typeof catRecordEn, string> = {
  'cat.history.empty': 'कोई दर्ज बदलाव नहीं',
  'cat.history.forbidden': 'इतिहास प्रतिबंधित है',
  'cat.history.forbiddenHint': 'ऑडिट लॉग के लिए ऑडिट अनुमति चाहिए।',
  'cat.holds.emptyTitle': 'इस शीर्षक पर कोई होल्ड नहीं',
  'cat.holds.emptyHint': 'सदस्यों या स्टाफ़ द्वारा लगाए गए होल्ड यहाँ कतार में दिखेंगे।',
  'cat.holds.placed': 'लगाया गया',
  'cat.holds.tableLabel': 'होल्ड कतार',
  'cat.item.accession': 'प्रवेश संख्या',
  'cat.item.act.changeLibrary': 'पुस्तकालय बदलें',
  'cat.item.act.damaged': 'क्षतिग्रस्त चिह्नित करें',
  'cat.item.act.delete': 'आइटम हटाएँ',
  'cat.item.act.edit': 'आइटम संपादित करें',
  'cat.item.act.found': 'मिला चिह्नित करें',
  'cat.item.act.history': 'परिसंचरण इतिहास',
  'cat.item.act.hold': 'आइटम होल्ड लगाएँ',
  'cat.item.act.label': 'लेबल छापें',
  'cat.item.act.lost': 'खोया चिह्नित करें',
  'cat.item.act.repaired': 'मरम्मत हुआ चिह्नित करें',
  'cat.item.act.restore': 'परिसंचरण में लौटाएँ',
  'cat.item.act.withdraw': 'हटाएँ (निकासी)',
  'cat.item.actionsFor': '{barcode} की क्रियाएँ',
  'cat.item.add': 'आइटम जोड़ें',
  'cat.item.addTitle': 'आइटम जोड़ें',
  'cat.item.autoBarcode': 'बारकोड स्वतः बनाएँ',
  'cat.item.barcode': 'बारकोड',
  'cat.item.barcodeAuto': 'सहेजने पर बनेगा',
  'cat.item.barcodeAutoHint': 'क्रम का अगला बारकोड लेने के लिए खाली छोड़ें।',
  'cat.item.batchConflicts': 'ये बारकोड पहले से मौजूद हैं: {list}',
  'cat.item.batchCopyStart': 'पहली प्रति संख्या',
  'cat.item.batchCount': 'प्रतियाँ',
  'cat.item.batchCreate': '{n} प्रतियाँ बनाएँ',
  'cat.item.batchDone': '{n} प्रतियाँ जोड़ी गईं',
  'cat.item.batchHint': 'क्रमिक बारकोड के साथ कई प्रतियाँ बनाएँ। टकराव पकड़ने के लिए पहले पूर्वावलोकन देखें।',
  'cat.item.batchPrefix': 'बारकोड उपसर्ग',
  'cat.item.batchPrefixHint': 'खाली = स्वचालित',
  'cat.item.batchPreview': 'पूर्वावलोकन',
  'cat.item.batchStart': 'यहाँ से शुरू',
  'cat.item.batchTitle': 'एक साथ कई प्रतियाँ जोड़ें',
  'cat.item.batchWidth': 'अंक',
  'cat.item.batchWillCreate': '{n} प्रतियाँ बनेंगी',
  'cat.item.callNumber': 'कॉल नंबर',
  'cat.item.changeLibrary': 'पुस्तकालय बदलें',
  'cat.item.choose': 'चुनें',
  'cat.item.classSource': 'वर्गीकरण स्रोत',
  'cat.item.collection': 'संग्रह',
  'cat.item.copyBarcode': 'बारकोड कॉपी करें',
  'cat.item.copyNumber': 'प्रति संख्या',
  'cat.item.created': 'आइटम {barcode} जोड़ा गया',
  'cat.item.damagedTitle': 'क्षतिग्रस्त चिह्नित करें',
  'cat.item.dateAccepted': 'प्राप्ति तिथि',
  'cat.item.deleteBody': 'आइटम {barcode} सूची से हटा दिया जाएगा। उधार पर चल रहे आइटम नहीं हटाए जा सकते।',
  'cat.item.deleteTitle': 'यह आइटम हटाएँ?',
  'cat.item.due': 'देय {date}',
  'cat.item.dueOrSeen': 'देय / अंतिम बार देखा',
  'cat.item.editTitle': 'आइटम {barcode} संपादित करें',
  'cat.item.emptyHint': 'पहली प्रति जोड़ें ताकि सदस्य यह शीर्षक उधार ले सकें।',
  'cat.item.emptyTitle': 'अभी कोई प्रति नहीं',
  'cat.item.failed': 'यह सफल नहीं हुआ',
  'cat.item.filter': 'प्रतियाँ छानें',
  'cat.item.historyDue': 'देय {date}',
  'cat.item.historyEmpty': 'यह प्रति कभी उधार नहीं ली गई',
  'cat.item.historyRenewals': '{n} नवीनीकरण',
  'cat.item.historyTitle': 'परिसंचरण इतिहास',
  'cat.item.holdingLibrary': 'धारक पुस्तकालय',
  'cat.item.homeLibrary': 'मूल पुस्तकालय',
  'cat.item.itemType': 'आइटम प्रकार',
  'cat.item.labelSheets': 'लेबल डिज़ाइनर में एक साथ कई लेबल छापें',
  'cat.item.labelTitle': 'आइटम लेबल',
  'cat.item.location': 'शेल्फ़ स्थान',
  'cat.item.lostStatus': 'खोने की स्थिति',
  'cat.item.lostTitle': 'खोया चिह्नित करें',
  'cat.item.moreFields': 'और फ़ील्ड',
  'cat.item.noBarcode': 'बारकोड नहीं',
  'cat.item.none': 'कोई नहीं',
  'cat.item.notForLoan': 'उधार स्थिति',
  'cat.item.note': 'टिप्पणी',
  'cat.item.price': 'मूल्य',
  'cat.item.print': 'छापें',
  'cat.item.publicNote': 'सार्वजनिक टिप्पणी',
  'cat.item.replacementPrice': 'प्रतिस्थापन मूल्य',
  'cat.item.restricted': 'सीमित पहुँच',
  'cat.item.saved': 'आइटम सहेजा गया',
  'cat.item.seen': 'देखा गया {date}',
  'cat.item.source': 'स्रोत',
  'cat.item.staffNote': 'स्टाफ़ टिप्पणी',
  'cat.item.status': 'स्थिति',
  'cat.item.tableLabel': 'इस शीर्षक की प्रतियाँ',
  'cat.item.unknownPatron': 'अज्ञात सदस्य',
  'cat.item.updated': 'आइटम अद्यतन हुआ',
  'cat.item.volume': 'खंड',
  'cat.item.withdrawTitle': 'आइटम निकालें',
  'cat.marc.copy': 'MARC कॉपी करें',
  'cat.marc.formatted': 'MARC',
  'cat.marc.none': 'कोई MARC रिकॉर्ड संचित नहीं',
  'cat.marc.noneHint': 'एक बनाने के लिए रिकॉर्ड संपादित करें।',
  'cat.marc.raw': 'कच्चा JSON',
  'cat.marc.tableLabel': 'MARC फ़ील्ड',
  'cat.marc.view': 'रिकॉर्ड प्रारूप',
  'cat.record.deleteBody': '\'{title}\' और उसकी {n} प्रतियाँ हटा दी जाएँगी। पुष्टि के लिए रिकॉर्ड संख्या लिखें।',
  'cat.record.deleteFailed': 'रिकॉर्ड हटाया नहीं जा सका',
  'cat.record.deleteTitle': 'यह रिकॉर्ड हटाएँ?',
  'cat.record.deleted': 'रिकॉर्ड हटाया गया',
  'cat.record.holds': '{n} होल्ड',
  'cat.record.notFound': 'रिकॉर्ड नहीं मिला',
  'cat.record.tabs': 'रिकॉर्ड अनुभाग',
  'cat.related.empty': 'कोई संबंधित शीर्षक नहीं मिला',
  'cat.reviews.average': '{n} रेटिंग से औसत {avg}',
  'cat.reviews.empty': 'अभी कोई समीक्षा नहीं',
  'cat.reviews.emptyHint': 'सदस्य सार्वजनिक सूची से शीर्षकों की समीक्षा कर सकते हैं।',
  'cat.reviews.moderate': 'मॉडरेशन कतार खोलें',
  'cat.reviews.pending': 'लंबित',
  'cat.reviews.unrated': 'अभी रेटिंग नहीं',
  'cat.tab.history': 'इतिहास',
  'cat.tab.holds': 'होल्ड',
  'cat.tab.items': 'आइटम',
  'cat.tab.marc': 'विवरण और MARC',
  'cat.tab.related': 'संबंधित',
  'cat.tab.reviews': 'समीक्षाएँ',
};
